import React from "react";
import styled from "styled-components";

const Play = styled.div`
  transform: translate(-6px, 0) scaleY(0.8) rotate(45deg);
`;
const PlayIcon = () => <Play>◥</Play>;

export default PlayIcon;
